import React, {Component} from "react";

class WinnersSelect extends Component {
    render() {
        const {onClick} = this.props;
        return (
            <>
                <select onClick={onClick} className="select txt-center" >
                    <option style={{fontFamily: "'Arial'"}} value="One" onClick={onClick} className="fs1_5">Konkurs 1: 02.03 - 08.03.2020r.</option>
                    <option style={{fontFamily: "'Arial'"}}  value="Two" onClick={onClick} className="fs1_5">Konkurs 2: 08.03 - 15.03.2020r.</option>
                    <option style={{fontFamily: "'Arial'"}}  value="Three" onClick={onClick} className="fs1_5">Konkurs 3: 16.03 - 22.03.2020r.</option>
                    <option style={{fontFamily: "'Arial'"}}  value="Four" onClick={onClick} className="fs1_5">Konkurs 4: 23.03 - 29.03.2020r.</option>
                    <option style={{fontFamily: "'Arial'"}}  value="Five" onClick={onClick} className="fs1_5">Konkurs 5: 30.03 - 05.04.2020r.</option>
                    <option style={{fontFamily: "'Arial'"}} selected="true" value="Six" onClick={onClick} className="fs1_5">Konkurs 6: 6.04 - 11.04.2020r.</option>
                </select>
            </>
        )
    }
}

export default WinnersSelect;